export default __webpack_public_path__ + "static/media/homeillus.42ba5123.png";